import { useLocation, useNavigation } from '@remix-run/react';
import { useLayoutEffect } from 'react';

export const AutoScrollToTop = () => {
  const location = useLocation();
  const { location: navigationLocation } = useNavigation();

  if (__BUILD_TARGET__ === 'client') {
    useLayoutEffect(() => {
      document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);

    useLayoutEffect(() => {
      document.documentElement.scrollTo(0, 0);
    }, [navigationLocation?.pathname]);
  }

  return null;
};
